var Api = {};

function setError(context, name, msg){
	context.errorSet(name, msg);
}

function setSuccess(context, name, msg){
	context.successSet(name, msg);
}

var endpoint = 'https://api.trackcommissions.com:444';


Api.install = function (Vue, options) {
	// 1. add global method or property
	Vue.prototype.$endpoint = function (context, fn, data) {
		return endpoint;
	};

	Vue.prototype.$send = function (context, fn, data, domain) {
		
		var send = {
			function: fn,
			data: data || null
		};

		var msgDomain = domain || 'general';
		
		return context.$http.post(endpoint, send, { emulateJSON: true}).then(response => {
			// context.stopLoading(context.$options.name);
			if(response.body.status){
				if(response.body.message){
					context.$store.commit('setStatus', {
						status: true,
						message:response.body.message
					});
				}


		//		setSuccess(context, context.$options.name, response.body.msg);
				return response.body.data;
			} else {
				context.$store.commit('setStatus', {
					status: false,
					message: response.body.message
				});
				throw new Error(response.body.message);
			}
		}).catch((err) => {
			console.log(err);
			context.finished = true;
			context.$store.commit('setStatus', {
				status: false,
				message: err.toString(),
				domain: msgDomain
			});

			return { error: err.toString() }

		});
	}
}


export default Api;


// WEBPACK FOOTER //
// ./src/plugins/Api.js